<template>
  <div>
    <Banner type="vehicle" />
    <div class="page-container j-container-box-shadow container">
      <span class="j-title title">{{ $t('vehicle.title') }}</span>

      <a-spin :spinning="loading">
        <div>
          <a-row :gutter="[45, 45]" v-if="vehicles.length > 0">
            <a-col
              :xs="24"
              :sm="24"
              :md="8"
              v-for="item in vehicles"
              :key="item.id"
            >
              <VehicleItem :vehicle="item" />
            </a-col>
          </a-row>

          <div class="j-no-result" v-if="loaded && vehicles.length === 0">
            <img
              alt="no-data"
              src="@/assets/images/noData.png"
              width="164"
              height="141"
            />
            <span class="no-data-msg j-content">
              {{ $t('common.coming_soon') }}
            </span>
          </div>
        </div>
      </a-spin>

      <div class="pagination-container" v-if="vehicles.length > 0">
        <a-pagination
          v-model:current="pageNo"
          :page-size-options="pageSizeOptions"
          :total="total"
          show-size-changer
          v-model:pageSize="pageSize"
          @showSizeChange="onShowSizeChange"
          @change="onChange"
          show-quick-jumper
        >
          <template #buildOptionText="props">
            <span>{{ props.value }} {{ $t('common.page_per_item_text') }}</span>
          </template>
        </a-pagination>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import VehicleItem from './VehicleItem.vue';
import { getVehicleList } from '@/api/apis';
import Banner from '@/components/banner/Banner.vue';

export default defineComponent({
  name: 'Vehicle',
  components: {
    VehicleItem,
    Banner
  },
  data() {
    return {
      loading: false,
      loaded: false,
      vehicles: [],
      pageNo: 1,
      pageSize: 6,
      pageSizeOptions: ['6', '12'],
      current: 1,
      total: 0
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      const res = await getVehicleList({
        pageNo: this.pageNo,
        pageSize: this.pageSize
      });

      if (res.success) {
        this.total = res.result.total;

        this.vehicles = res.result.records;
      }

      this.loading = false;
      this.loaded = true;
    },
    onShowSizeChange() {
      this.pageNo = 1;
      this.loadData();
    },
    onChange() {
      this.loadData();
    }
  }
});
</script>

<style lang="scss" scoped>
.container {
  padding: 0 49px;
  background-color: white;

  .title {
    padding: 32px 0 29px 0;
    display: block;
  }

  .pagination-container {
    padding: 38px 0 40px 0;
    text-align: right;
  }
}

::v-deep(.ant-btn) {
  padding: 10.5px 0;
}
</style>
